function applyShadowStyles(formsId) {
    const embed = document.querySelector(`[data-forms-id='${formsId}'] shopify-forms-embed`);

    if (!embed || !embed.shadowRoot) {
      setTimeout(() => applyShadowStyles(formsId), 500);
      return;
    }

    const styles = {
      'forms-root-982552': `
        [data-sizing="form-wrapper"] {
            margin: 0 !important;
            width: 100% !important;
            max-width: 100% !important;
            display: flex !important;
            min-height: auto !important;
        }

        [data-sizing="form-wrapper"] div:last-child {
            padding: 0 !important;
            width: 100%;
        }

        [data-testid="form"] {
            flex-direction: row !important;
            gap: 0 !important;
            padding: 0 !important;
            flex-wrap: wrap;
        }

        [data-testid="form"] div:nth-child(2) {
          width: 100%;
          height: 100%;
          max-width: 419px !important;
        }

        [data-testid="form"] button {
          border-radius: 10px !important;
          margin-left: 16px !important;
        }

        [data-testid="field-email"] {
          padding: 22px 24px !important;
          background: #FFFFFF1A !important;
          border-radius: 10px !important;
          border: 1px solid #FFFFFF33 !important;
          outline: none !important;
          box-shadow: unset !important;
          font-weight: 400 !important;
          font-size: 18px !important;
          line-height: 100% !important;
          letter-spacing: normal !important;
          color: var(--white) !important;
          padding-left: 64px !important;
        }

        [data-testid="field-email"]:focus-within + #label-email:before,
        [data-testid="field-email"]:focus-visible + #label-email:before,
        [data-testid="field-email"]:has(input:focus) + #label-email:before,
        [data-testid="field-email"].has-email-value + #label-email:before,
        #label-email.has-email-value:before,
        [data-testid="field-email"]:has(input:not(:placeholder-shown)) + #label-email:before {
          display: none !important;
        }

        #label-email {
          font-size: 0 !important;
          top: 50% !important;
          transform: translateY(-50%) !important;
          left: 64px !important;
          display: flex;
          align-items: center;
          flex-direction: row-reverse;
        }

        #label-email:before {
          content: 'Enter your email';
          font-weight: 400;
          font-size: 18px;
          line-height: 100%;
          letter-spacing: normal;
          color: var(--white);
        }

        #label-email:after {
          content: '';
          background-image: url(https://cdn.shopify.com/s/files/1/1022/7141/8651/files/Icon.svg?v=1778483930);
          width: 24px;
          height: 24px;
          display: block;
          position: absolute;
          left: -40px;
        }

        [data-testid="field-email"]:before {
            content: '' !important;
        }

        [data-testid="btn-form-submit"] {
          width: 100% !important;
          max-width: 227px !important;
          background: var(--blue) !important;
          display: flex !important;
          align-items: center !important;
          font-weight: 700 !important;
          font-size: 18px !important;
          line-height: 28px !important;
          letter-spacing: normal !important;
          text-align: center !important;
          text-transform: uppercase !important;
          position: relative;
          gap: 8px;
          justify-content: center;
        }

        [data-testid="btn-form-submit"]::after {
          content: "";
          display: inline-block;
          width: 18px;
          height: 18px;
          margin-left: 15px;
          background-image: url("https://cdn.shopify.com/s/files/1/1022/7141/8651/files/icon-download.svg?v=1778485853");
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
        }

        [data-testid="app-router"] {
          display: block !important;
        }

        @media (max-width: 989px) {
          [data-testid="form"] {
            flex-direction: column !important;
          }

          [data-testid="form"] button {
            margin-left: 0 !important;
            margin-top: 16px !important;
          }
        }

        @media (max-width: 749px) {
          [data-testid="form"] {
            align-items: center;
          }

          [data-testid="btn-form-submit"] {
            max-width: 210px !important;
            font-size: 16px !important;
            padding: 14px 15px !important;
          }

          [data-testid="field-email"] {
            padding: 16.5px 24px !important;
            padding-left: 64px !important;
          }
        }
      `,

      'forms-root-1012586': `
        [data-testid="field-email"].has-value + #label-email,
        #label-email.has-value,
        [data-testid="field-first_name"].has-value + #label-first_name,
        #label-first_name.has-value {
          display: none !important;
        }

        [data-testid="form"] label {
          font-size: 18px !important;
          display: flex;
          align-items: center;
          flex-direction: row-reverse;
          left: 24px !important;
          top: 50% !important;
          transform: translateY(-50%) !important;
        }

        [data-testid="field-first_name"],
        [data-testid="field-email"] {
          padding: 22px 24px !important;
          background: #FFFFFF1A !important;
          border-radius: 10px !important;
          border: 1px solid var(--blue) !important;
          outline: none !important;
          box-shadow: unset !important;
          font-weight: 400 !important;
          font-size: 18px !important;
          line-height: 100% !important;
          letter-spacing: normal !important;
          color: var(--black) !important;
        }

        input:focus-within + label,
        input:focus-visible + label,
        input:has(input:focus) + label,
        input.has-email-value + label,
        input:has(input:not(:placeholder-shown)) + label {
          display: none !important;
        }

        [data-testid="btn-form-submit"] {
          width: 100% !important;
          max-width: 180px !important;
          background: var(--blue) !important;
          display: flex !important;
          align-items: center !important;
          font-weight: 700 !important;
          font-size: 18px !important;
          line-height: 28px !important;
          letter-spacing: normal !important;
          text-align: center !important;
          text-transform: uppercase !important;
          position: relative;
          gap: 8px;
          justify-content: center;
          margin: 0 auto !important;
          border-radius: 10px !important;
        }

        [data-sizing="form-wrapper"] h2 {
          font-size: 30px !important;
          line-height: 40px !important;
          margin: 0 0 20px !important;
          font-weight: 500 !important;
        }

        @media (max-width: 749px) {

          [data-sizing="form-wrapper"] h2 {
            font-size: 22px !important;
            line-height: 28px !important;
            margin: 0 0 10px !important;
          }

          [data-testid="form"] label {
            font-size: 15px !important;
          }

          [data-testid="field-first_name"], [data-testid="field-email"] {
            font-size: 15px !important;
            padding: 16.5px 24px !important;
            padding-left: 64px !important;
            border-radius: 5px !important;
          }

          [data-testid="btn-form-submit"] {
            padding: 13px !important;
          }

        }


      `
    };

    if (!embed.shadowRoot.querySelector('#custom-form-style')) {
      const style = document.createElement('style');
      style.id = 'custom-form-style';
      style.textContent = styles[formsId] || '';
      embed.shadowRoot.appendChild(style);
    }

    const setupFieldLabelVisibility = (fieldTestId, labelId) => {
      const field = embed.shadowRoot.querySelector(
        `[data-testid="${fieldTestId}"]`
      );

      const input = field?.matches('input, textarea')
        ? field
        : field?.querySelector('input, textarea');

      const label = embed.shadowRoot.querySelector(`#${labelId}`);

      if (!field || !input) {
        setTimeout(() => {
          setupFieldLabelVisibility(fieldTestId, labelId);
        }, 250);
        return;
      }

      const updateLabelVisibility = () => {
        const hasValue = input.value.trim() !== '';

        field.classList.toggle('has-value', hasValue);

        if (label) {
          label.classList.toggle('has-value', hasValue);
        }
      };

      updateLabelVisibility();

      const listenerKey = `listenerAdded${fieldTestId.replace(/[^a-zA-Z0-9]/g, '')}`;

      if (!input.dataset[listenerKey]) {
        input.dataset[listenerKey] = 'true';

        input.addEventListener('input', updateLabelVisibility);
        input.addEventListener('change', updateLabelVisibility);
        input.addEventListener('blur', updateLabelVisibility);
      }
    };

    setupFieldLabelVisibility('field-email', 'label-email');

    if (formsId === 'forms-root-1012586') {
      setupFieldLabelVisibility('field-first_name', 'label-first_name');
    }

    document.querySelector(`[data-forms-id='${formsId}']`).style.display = 'block';
  }

  document.addEventListener('DOMContentLoaded', () => {
    applyShadowStyles('forms-root-982552');
    applyShadowStyles('forms-root-1012586');
  });

  (() => {
    const countdownSelector = '[data-sale-countdown]';

    const formatNumber = (number) => String(number).padStart(2, '0');

    const formatRemainingTime = (milliseconds) => {
      const totalSeconds = Math.floor(milliseconds / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      const time = `${formatNumber(hours)}h ${formatNumber(minutes)}m ${formatNumber(seconds)}s`;

      return days > 0 ? `${days}d ${time}` : time;
    };

    const updateSaleCountdowns = () => {
      document.querySelectorAll(countdownSelector).forEach((countdown) => {
        const endDate = Date.parse(countdown.dataset.saleEnd || '');
        const output = countdown.querySelector('[data-sale-countdown-output]');

        if (!endDate || !output) {
          countdown.hidden = true;
          return;
        }

        const remainingTime = endDate - Date.now();

        if (remainingTime <= 0) {
          countdown.hidden = true;
          return;
        }

        output.textContent = formatRemainingTime(remainingTime);
        countdown.hidden = false;
      });
    };

    document.addEventListener('DOMContentLoaded', () => {
      updateSaleCountdowns();
      setInterval(updateSaleCountdowns, 1000);
    });
  })();